@if (!!status) {
  <span class="chip-questionnaire-status"
      [ngClass]="{'blue': status.key === 'IN_PROGRESS',
                 'green': status.key === 'CONFIRMED',
                 'red': status.key === 'RECEIVED',
                 'grey': status.key === 'NOT_STARTED'}"></span>
}